import { Component } from '@angular/core';

import { BookingActionBaseComponent } from './booking-action.base-component';

@Component({
  template: '',
  standalone: false,
})
export abstract class ExplainStorageTimerActionBaseComponent extends BookingActionBaseComponent {}
